<template>
  <v-row no-gutters :style="{ 'min-height': '100vh' }">
    <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3" xl="4" offset-xl="4" class="pa-4">
      <v-row>
        <v-col cols="12">
          <div class="mt-10">
            <div class="text-center" style="height: 150px;">
              <lottie-player
                v-pre
                src="https://assets2.lottiefiles.com/packages/lf20_ybjkzksv.json"
                background="transparent"
                speed="3"
                loop
                autoplay
                style="width: 300px; height: 150px; display: inline;"
              ></lottie-player>
            </div>

            <h1 class="text-center mt-5 mb-10 text-h2">
              Import
            </h1>

            <p class="text-justify">
              You can import your bookmarks from another browser to Bookmark Expert very easily. First
              you need to export your bookmarks from your browser as a HTML file. Here are some guides how to export
              bookmarks from
              <a href="https://support.google.com/chrome/answer/96816?hl=en" target="_blank">Chrome</a>
              ,
              <a
                href="https://www.ionos.com/digitalguide/websites/web-development/export-safari-bookmarks/"
                target="_blank"
              >
                Safari
              </a>
              ,
              <a href="https://support.mozilla.org/tr/kb/export-bookmarks-safari" target="_blank">
                Firefox
              </a>
              or
              <a
                href="https://forums.opera.com/topic/40531/exporting-bookmarks-and-settings-from-opera-to-other-browsers"
                target="_blank"
              >
                Opera
              </a>
              .
            </p>
            <p>
              Afterwards, select your import location and select the exported bookmarks file below.
              Please not that
              <em>Import</em>
              does not delete any data, it merges the imported bookmarks with your current data in
              Bookmark Expert.
            </p>

            <div class="text-center mt-10">
              <h2 class="text-overline primary--text">IMPORT TO</h2>
              <ParentSelector v-model="import_location" />
            </div>

          </div>
        </v-col>
      </v-row>
      <v-row class="mt-10">
        <v-col cols="12" md="6"  class="pb-5">
          <v-card class="text-center px-10 py-8" color="grey lighten-4" flat>
            <v-btn color="primary" large @click="uploadHTML">
              <v-icon left>mdi-upload</v-icon> upload html file
            </v-btn>
            <input
              ref="html_upload"
              class="d-none"
              type="file"
              accept=".html"
              @change="onFileHTMLChanged"
            />
          </v-card>
          <p class="text-justify mt-5">
            Global file type for bookmarks. Does not include Bookmark Expert specific features such as <em>notes</em>, favorites or whether folders
            are <em>hidden</em> or not. Use it to:
              <ul class="mt-5">
                <li>Import them to another application such as Chrome, Safari, Firefox and Opera</li>
              </ul>
          </p>
        </v-col>
        <v-col cols="12" md="6" class="pb-5">
          <v-card class="text-center px-10 py-8" color="grey lighten-4" flat>
            <v-btn color="primary" large @click="uploadJSON">
              <v-icon left>mdi-upload</v-icon> upload json file
            </v-btn>
            <input
              ref="json_upload"
              class="d-none"
              type="file"
              accept=".json"
              @change="onFileJSONChanged"
            />
          </v-card>
          <p class="text-justify mt-5">
            File type that holds all features of bookmarks such as notes, favorites and whether folders
            are <em>hidden</em> or not. Use it to:
            <ul class="mt-5">
              <li>Take snapshot for your Bookmark Expert data</li>
              <li>Share with other Bookmark Expert users</li>
            </ul>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ParentSelector from "../components/ParentSelector";
const { v4: uuidv4 } = require("uuid");

export default {
  name: "Import",
  metaInfo() {
    return this.generateMeta({ name: "import", path: this.$route.path });
  },
  components: { ParentSelector },
  data() {
    return {
      import_location: {
        id: 0,
        label: "Home",
      },
      loading: false,
    };
  },
  methods: {
    uploadHTML() {
      this.$refs.html_upload.click();
    },
    uploadJSON() {
      this.$refs.json_upload.click();
    },
    onFileJSONChanged(e) {
      this.loading = true;
      // console.log("onFileChanged");
      let import_to_id = this.import_location.id;
      let file = this.$refs.json_upload.files[0];
      // console.log(file.type, "file.type");
      // if (!file || file.type !== "application/json") {
      //   return this.error("Not a JSON file!");
      // }
      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");

      reader.onerror = (e) => {
        this.loading = false;
        this.$store.commit("updateStateSnackbar", {
          open: true,
          html: "There is a problem !",
          icon: "error",
          timeout: 5000,
          action: "close",
        });
        console.error(e);
        return this.error(e.message);
      };

      reader.onload = async (evt) => {
        try {
          // let json = JSON.parse(evt.target.result);
          let text = evt.target.result;
          console.log(evt.target.result, "file contents");

          var json = JSON.parse(text)
          // console.log(json, 'json')

          let next_order =
            this.$store.getters.whole_list
              .filter((g) => g.parent == import_to_id)
              .reduce(function(acc, val) {
                return acc > val.order ? acc : val.order;
              }, 0) + 1
          // sort according to values
          json.sort((a, b) => (a.order > b.order ? 1 : -1))


          // change ids for possible collusions and store mapping
          let id_map = {}
          json.forEach(item=>{
            const newId = uuidv4()
            id_map[item.id] = newId
            item.id = newId
          })

          // make adjustments on data
          json.forEach(item=>{
            if(item.parent == 0){
              // change root parent to selected folder
              item.parent = import_to_id,
              // increase root parent item orders 
              item.order = next_order++
            }else{
              item.parent = id_map[item.parent]
            }

            // fix datetimes
            if(item.createdAt) item.createdAt = new Date(item.createdAt.seconds * 1000)
            if(item.updatedAt) item.updatedAt = new Date(item.updatedAt.seconds * 1000)
            if(item.favoritedAt) item.favoritedAt = new Date(item.favoritedAt.seconds * 1000)

            delete item.encryptedDecrypted
          })
          // console.log(json, 'json')

          await this.$store.dispatch("encryptAndMutateItems", {
            items: json,
            forceCreate: true,
          });

          this.$refs.json_upload.value = "";
          this.loading = false;

          this.$router.push(`/bookmarks/${this.import_location.id}`);
        } catch (e) {
          console.error(e);
          this.loading = false;
          this.$store.commit("updateStateSnackbar", {
            open: true,
            html: "There is a problem!",
            icon: "error",
            timeout: 5000,
            action: "close",
          });
        }
      };
    },
    onFileHTMLChanged(e) {
      this.loading = true;
      // console.log("onFileChanged");
      let import_to_id = this.import_location.id;
      let file = this.$refs.html_upload.files[0];
      // console.log(file.type, "file.type");
      // if (!file || file.type !== "application/json") {
      //   return this.error("Not a JSON file!");
      // }
      let reader = new FileReader();
      reader.readAsText(file, "UTF-8");

      reader.onerror = (e) => {
        this.loading = false;
        this.$store.commit("updateStateSnackbar", {
          open: true,
          html: "There is a problem !",
          icon: "error",
          timeout: 5000,
          action: "close",
        });
        console.error(e);
        return this.error(e.message);
      };

      reader.onload = async (evt) => {
        try {
          // let json = JSON.parse(evt.target.result);
          let text = evt.target.result;
          console.log(evt.target.result, "file contents");

          // remove p tags
          // text = text.replace(/<dt><h3/gi, "<p");
          // text = text.replace(/<\/h3>/gi, "</p>");
          // text = text.replace(/<dl><p>/gi, "<li>");
          // text = text.replace(/<\/dl><p>/gi, "</li>");
          // text = text.replace(/<dt><a/gi, "<a");
          // text = text.replace(/<\/a>/gi, "</a>");
          // text = text.replace(/<dt>/gi, "");
          // text = text.replace(/<DT>/gi, "");
          text = text.replace(/<dl><p>/gi, "<dl>");
          text = text.replace(/<\/dl><p>/gi, "</dl>");
          text = text.replace(/<dt><h3/gi, "<h3");
          text = text.replace(/<dt><a/gi, "<a");
          text = text.replace(/<dl>\s*<\/dl>/gi, "");
          console.log(text, "text");

          var dom = document.createElement("bookmarks_html");
          dom.innerHTML = text;
          console.log(dom, "el");

          // console.log("Direct children ");
          // Chrome, Firefox and Opera has a DL wrapper tag whereas Safari does not
          // if ([...dom.querySelectorAll(":scope > a")].length) {
          //   console.warn("Safari Bookmarks!");
          // } else {
          //   console.warn("Not Safari Bookmarks!");
          //   dom = dom.querySelector(":scope > li");
          // }
          // console.log(dom, "el2");

          let next_order =
            this.$store.getters.whole_list
              .filter((g) => g.parent == import_to_id)
              .reduce(function(acc, val) {
                return acc > val.order ? acc : val.order;
              }, 0) + 1;
          // insert order attribute tags
          function recursiveOrderer(dom) {
            // debugger;
            let order = next_order; // normally only root level items need to start from this order but I am doing it to all items, it does not matter
            for (let i = 0; i < dom.children.length; i++) {
              if (
                dom.children[i].tagName.toLowerCase() == "a" ||
                dom.children[i].tagName.toLowerCase() == "h3"
              ) {
                dom.children[i].setAttribute("order", order++);
              } else if (dom.children[i].tagName.toLowerCase() == "dl") {
                recursiveOrderer(dom.children[i]);
              }
            }
          }

          recursiveOrderer(dom);
          console.log(dom, "ordered");

          function flattenBookmarks(dom) {
            let response = [];
            // assign id to all folder and links
            const items = dom.querySelectorAll("a, h3");
            for (let i = 0; i < items.length; i++) {
              items[i].setAttribute("uid", uuidv4());
            }

            for (let i = 0; i < items.length; i++) {
              let item = items[i];
              let obj = {};

              const parent_dl = item.closest("dl");
              const parent_dl_sibling = parent_dl ? parent_dl.previousElementSibling : null;

              obj = {
                id: item.getAttribute("uid"),
                type: item.tagName.toLowerCase() == "a" ? "url" : "folder",
                label: item.innerText,
                parent:
                  parent_dl_sibling && parent_dl_sibling.tagName.toLowerCase() == "h3"
                    ? parent_dl_sibling.getAttribute("uid")
                    : import_to_id,
                // parent_label:
                //   parent_dl_sibling.tagName.toLowerCase() == "h3"
                //     ? parent_dl_sibling.innerText
                //     : "home",
                order: parseInt(item.getAttribute("order")),
              };

              if (obj.type == "url") obj.url = item.getAttribute("href");

              response.push(obj);
            }
            console.log(response, `response`);
            return response;
          }

          // console.log(el.querySelector("dl"), "el2");
          // console.log(recursiveChecker(el.querySelector("dl")), "el3");
          const items = flattenBookmarks(dom);
          console.log(items, "el4");
          // return;
          // import
          // this.$store.dispatch("firestoreAddBookmarks", {
          //   items: items,
          //   success_route_id: this.import_location.id,
          // });
          await this.$store.dispatch("encryptAndMutateItems", {
            items: items,
            forceCreate: true,
          });

          this.$refs.html_upload.value = "";
          this.loading = false;

          this.$router.push(`/bookmarks/${this.import_location.id}`);
        } catch (e) {
          console.error(e);
          this.loading = false;
          this.$store.commit("updateStateSnackbar", {
            open: true,
            html: "There is a problem!",
            icon: "error",
            timeout: 5000,
            action: "close",
          });
        }
      };
    },
  },
};
</script>
